'strict';

require('jquery');
require('jquery-smooth-scroll');
require('magnific-popup');
require('./plugins/jquery.greedy-navigation.js');

import { prefersReducedMotion } from '../lib/motion';
import { installDeclarativeActions } from '../lib/declarative_actions';

installDeclarativeActions();

/* ==========================================================================
   jQuery plugin settings and other scripts
   ========================================================================== */

jQuery(document).ready(()=>{
  const $ = jQuery;

  /* Removed with the Jekyll theme's sidebar layer: a no-op "sticky footer"
     (its only statement was already commented out, but it still ran a 250 ms
     setInterval and a resize handler forever), the sticky-sidebar toggle, and
     the follow-menu dropdown. All three drove `.sidebar` / `.author__urls*`,
     which this site has never rendered. The live sticky behaviour is the
     masthead one in app/main.js, which is unrelated. */

  // Search toggle
  $(".search__toggle").on("click", function() {
    // aria-expanded has to follow the panel, not the click count: several
    // handlers bind to this button, so derive it from the class we just set.
    const open = $(".search-content").toggleClass("is--visible").hasClass("is--visible");
    this.setAttribute("aria-expanded", open ? "true" : "false");
    $(".initial-content").toggleClass("is--hidden");
    // set focus on input
    setTimeout(function() {
      $(".search-content input").focus();
    }, 400);
  });

  // Site-wide search: debounced fetch from /dynamic/search.php
  (function () {
    const searchInput = document.getElementById('site-search');
    const resultsDiv  = document.getElementById('results');
    const tpl         = document.getElementById('search-result-tpl');
    if (!searchInput || !resultsDiv || !tpl) return;

    let debounceTimer = null;

    function clearResults() { resultsDiv.innerHTML = ''; }

    function renderResults(data) {
      clearResults();
      const sections = [
        { key: 'members',         label: 'Members' },
        { key: 'posts',           label: 'Projects' },
        { key: 'publications',    label: 'Publications' },
        { key: 'talks',           label: 'Talks' },
        { key: 'collab_projects', label: 'Collaborations' },
        { key: 'static_pages',    label: 'Pages' },
      ];
      let total = 0;
      sections.forEach(function (section) {
        const items = data[section.key] || [];
        if (!items.length) return;
        total += items.length;
        const h = document.createElement('h3');
        h.className   = 'search-results__section-heading';
        h.textContent = section.label;
        resultsDiv.appendChild(h);
        items.forEach(function (item) {
          const node = tpl.content.cloneNode(true).firstElementChild;
          const link = node.querySelector('.search-result__link');
          const type = node.querySelector('.search-result__type');
          link.href        = item.url;
          link.textContent = item.title;
          type.textContent = item.type;
          resultsDiv.appendChild(node);
        });
      });
      if (total === 0) {
        const msg = document.createElement('p');
        msg.className   = 'results__found';
        msg.textContent = 'No results found.';
        resultsDiv.appendChild(msg);
      }
    }

    function doSearch(q) {
      clearResults();
      if (q.length < 2) return;
      fetch('/dynamic/search.php?q=' + encodeURIComponent(q), { credentials: 'same-origin' })
        .then(function (r) {
          return r.json().then(function (json) {
            if (r.status === 429) {
              const msg = document.createElement('p');
              msg.className   = 'results__found';
              msg.textContent = json.error || 'Too many searches. Please wait a moment.';
              resultsDiv.appendChild(msg);
              return;
            }
            if (r.ok && json.return_code === '1') renderResults(json.data);
          });
        })
        .catch(function () { /* silent: don't expose network errors to the user */ });
    }

    // 'input' rather than 'keyup': paste-by-mouse and the native clear button
    // both change the value without ever firing a key event.
    $(searchInput).on('input', function () {
      const q = searchInput.value.trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { doSearch(q); }, 300);
    });

    // Clear results when the search panel is toggled closed
    $('.search__toggle').on('click', clearResults);
  }());

  // init smooth scroll
  //
  // Scoped to in-page hash links: binding every <a> on the page also hijacked
  // the skip link, so keyboard users got an animated pan instead of a jump to
  // content. Skipped entirely under reduced motion, which the CSS already
  // respects but this plugin did not.
  if (!prefersReducedMotion()) {
    $('a[href^="#"]').smoothScroll({ offset: -20 });
  }

  // add lightbox class to all image links
  $(
    "a[href$='.jpg'],a[href$='.jpeg'],a[href$='.JPG'],a[href$='.png'],a[href$='.gif']"
  ).addClass("image-popup");

  // Magnific-Popup options
  $(".image-popup").magnificPopup({
    // disableOn: function() {
    //   if( $(window).width() < 500 ) {
    //     return false;
    //   }
    //   return true;
    // },
    type: "image",
    tLoading: "Loading image #%curr%...",
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
    },
    image: {
      tError: '<a href="%url%">Image #%curr%</a> could not be loaded.'
    },
    removalDelay: 500, // Delay in milliseconds before popup is removed
    // Class that is added to body when popup is open.
    // make it unique to apply your CSS animations just to this exact popup
    mainClass: "mfp-zoom-in",
    callbacks: {
      beforeOpen: function() {
        // just a hack that adds mfp-anim class to markup
        this.st.image.markup = this.st.image.markup.replace(
          "mfp-figure",
          "mfp-figure mfp-with-anim"
        );
      }
    },
    closeOnContentClick: true,
    midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
  });
});
